import React from 'react'
import PropTypes from 'prop-types'
import { Container, Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap'
import { Link } from 'react-router-dom'
import styles from './Header.scss'

export class Header extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      isOpen: false
    }
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  render () {
    const { user, onLogout } = this.props
    return (
      <div>
        <Navbar light toggleable className={styles.Header}>
          <NavbarToggler className={styles.toggler} right onClick={this.toggle} />
          <Container>
            <NavbarBrand tag={Link} to='/'>
              <img alt='OTC' height='22' src='/images/OTC_header_logo.png' />
            </NavbarBrand>
            {
              this.props.user &&
              <Collapse isOpen={this.state.isOpen} navbar>
                <Nav className='mr-auto' navbar>
                  <NavItem>
                    <NavLink tag={Link} to='/pages' >Pages</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} to='/files' >Files</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} to='/documents' >Docs</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} to='/images' >Images</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} to='/settings' >Settings</NavLink>
                  </NavItem>
                </Nav>
              </Collapse>
            }
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className='ml-auto' navbar>
                <NavItem>
                  { user
                    ? <NavLink onClick={onLogout} href='#'>
                      {user.firstName ? `${user.firstName} ${user.lastName}` : (user.username || user.email)} | Logout
                    </NavLink>
                    : <NavLink tag={Link} to='/login'>Login</NavLink>
                  }
                </NavItem>
              </Nav>
            </Collapse>
          </Container>
        </Navbar>
      </div>
    )
  }
}

Header.propTypes = {
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }),
  onLogout: PropTypes.func
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.js